<script lang="ts">
  import {fly} from 'svelte/transition'
  import {modal} from '../stores/modal'
  import SearchModal from './SearchModal.svelte'
  import Register from '../authentication/Register.svelte'
  import {user} from '../stores/user'
  import {changeLocale, lang, locales, t} from '../i18n'
  import {Link, navigate} from 'svelte5-router'
  import api from '../api/api'
  import DropdownWrapper from './DropdownWrapper.svelte'
  import logo from '../../images/poetree_main_logo_small.png'
  import NotificationsDropdown from '../notifications/NotificationsDropdown.svelte'
  import LoginSocial from '../../src/authentication/LoginSocial.svelte'
  import {sidebarOpened} from '../../src/stores/sidebar'

  function openSearch() {
    modal.show(SearchModal)
  }

  async function logout(e: Event) {
    e.preventDefault()
    await api.delete('/logout')
    navigate('/')
    $user = undefined
  }

  function openLogin(e: Event) {
    e.preventDefault()
    modal.show(LoginSocial)
  }

  function openRegister(e: Event) {
    e.preventDefault()
    modal.show(Register)
  }

  function onChangeLocale(event: Event, locale: { code: string }) {
    event.preventDefault()
    changeLocale(locale.code)
  }

  function onOpenSidebar(e: Event) {
    e.stopPropagation()
    $sidebarOpened = true
  }
</script>

<div class="ui menu main-menu">
  <Link class="item brand-name" to="/">
    <img src={logo} alt="Poetree"/>
  </Link>

  <div class="center menu">
    <Link class="item" to="/explore">{t.topbar.explore}</Link>
    <Link class="item" to="/poets">{t.topbar.classics}</Link>
    {#if $user}
      <Link class="item" to={`/authors/${$user.handle}`}>{t.topbar.my_page}</Link>
    {/if}
    <Link class="item" to="/collections">{t.topbar.collections}</Link>
    <div class="item open-search" onclick={openSearch}>
      <i class="search-icon icon-p-lupa"></i> {t.topbar.find}
    </div>
  </div>

  {#if $user}
    <div class="right menu">
      <Link class="item" to="/poems/new">{t.topbar.add_poem}</Link>
      <NotificationsDropdown/>

      <DropdownWrapper class="ui item dropdown" let:show>
        <div class="user-pic">
          <img src={$user.avatar_big_thumgb} alt="User Avatar"/>
        </div>
        <i class="dropdown icon icon-p-drop-arrow"></i>

        {#if show}
          <div class="menu transition visible right-menu">
            <Link class="item" to="/settings">{t.topbar.account_settings}</Link>
            <Link class="item" to="/favorite">{t.topbar.favorite_poems}</Link>
            <Link class="item" to="/my-poems">{t.topbar.my_poems}</Link>
            <Link class="item" to="/my-collections">{t.topbar.my_collections}</Link>
            <Link class="item" to="/statistics">{t.topbar.my_statistics}</Link>
            <a class="item" href="#" onclick={logout}>{t.topbar.logout}</a>
          </div>
        {/if}
      </DropdownWrapper>

      <div class="item sidebar-toggle">
        <span class="open-menu">{t.topbar.menu}</span>
      </div>
    </div>
  {:else}
    <div class="right menu not-logged">
      <DropdownWrapper class="ui item dropdown lang-switch" let:show>
        <div class="text">{t.locales[lang ?? ''] ?? ''}</div>
        <i class="dropdown icon icon-p-drop-arrow"></i>

        {#if show}
          <div class="menu transition visible" transition:fly={{duration: 500}}>
            {#each locales as localeItem}
              <a class="item" href="#" onclick={(e) => onChangeLocale(e, localeItem)}>
                {t.locales[localeItem.code]}
              </a>
            {/each}
          </div>
        {/if}
      </DropdownWrapper>

      <a class="item" onclick={openLogin}>{t.topbar.login}</a>
      <a class="item" onclick={openRegister}>{t.topbar.register}</a>
    </div>
  {/if}

  <div class="mobile-nav">
    <span class="open-search" onclick={openSearch} role="button">
      <i class="search-icon icon-p-lupa"></i>
    </span>
    <div class="menu-toggle" onclick={onOpenSidebar} role="button">
      <i></i>
    </div>
  </div>
</div>